type ParsedBlock = {
    tableTitle?: string;
    headers: string[];
    data: string[][];
};
export const isEmptyOrZeroRow = (row: string[]) =>
    row.every((cell) => {
        const value = cell.trim();
        return value === '' || value === '0';
    });

export const parseBlocks = (values: string[][]): ParsedBlock[] => {
    const result: ParsedBlock[] = [];

    let currentBlock: ParsedBlock | null = null;
    let lastRowWasEmpty = false;
    let heatCounter = 1;

    const getNonEmptyCells = (row: string[]) => row.filter((cell) => cell.trim() !== '');

    const isSingleValueRow = (row: string[]) => getNonEmptyCells(row).length === 1;

    for (let i = 0; i < values.length; i++) {
        const row = values[i];

        // 🧹 Skip garbage
        if (isEmptyOrZeroRow(row)) {
            lastRowWasEmpty = true;

            if (currentBlock?.data.length === 1) {
                currentBlock = null;
            }

            continue;
        }

        const nonEmptyCells = getNonEmptyCells(row);

        // 🏷️ TABLE TITLE
        if (isSingleValueRow(row)) {
            // push previous block
            if (currentBlock) {
                result.push(currentBlock);
            }

            currentBlock = {
                tableTitle: nonEmptyCells[0],
                headers: [],
                data: [],
            };

            lastRowWasEmpty = false;
            continue;
        }

        if (lastRowWasEmpty && nonEmptyCells.length > 1) {
            if (currentBlock) {
                result.push(currentBlock);
            }

            if (heatCounter === 1) {
                result[0].tableTitle = `Heat ${heatCounter++}`;
            }

            currentBlock = {
                tableTitle: `Heat ${heatCounter++}`,
                headers: result[0].headers,
                data: [],
            };
            currentBlock.data.push(result[0].headers);

            lastRowWasEmpty = false;
        }

        // 🧠 HEADERS (first non-title row in a block)
        if (currentBlock && currentBlock.headers.length === 0) {
            if (!row.some((h) => h.trim().toLowerCase() === 'rnk')) {
                currentBlock.headers = values[0];
                currentBlock.data.push(values[0]);
            } else {
                currentBlock.headers = row;
            }
            currentBlock.data.push(row);
            lastRowWasEmpty = false;
            continue;
        }

        // 📊 DATA
        if (currentBlock) {
            currentBlock.data.push(row);
        } else {
            // edge case: no title, start block anyway
            currentBlock = {
                headers: row,
                data: [row],
            };
        }

        lastRowWasEmpty = false;
    }

    // push last block
    if (currentBlock) {
        result.push(currentBlock);
    }

    return result;
};
